/* eslint-disable */
import { combineReducers } from 'redux'
import configureStore from './CreateStore'
import rootSaga from '../Sagas/'
import { persistStore,persistCombineReducers,persistReducer } from 'redux-persist';
import { AsyncStorage } from '@react-native-async-storage/async-storage'
import { reducer as formReducer } from 'redux-form';
import ReduxPersist from '../Config/ReduxPersist'
/* ------------- Assemble The Reducers ------------- */
//export const reducers = combineReducers({
// to handle logout go 1 more level, see below
const appReducer = combineReducers({
  nav: require('./NavigationRedux').reducer,
  swiper: require('./SwiperRedux').reducer,
  loginNav: require('./NavigationRedux').loginReducer,
  relogin: require('./ReloginRedux').reducer,
  message : require('./MessagesRedux').reducer,
//   github: require('./GithubRedux').reducer,
  search: require('./SearchRedux').reducer,
  auth: require('./AuthRedux').reducer,
  websocket: require('./WebSocketRedux').reducer,
  signup: require('./SignUpRedux').reducer,
  user: require('./UserRedux').reducer,
  paypal: require('./PaypalRedux').reducer,
  follow: require('./FollowRedux').reducer,
  whoFollow: require('./WhoFollowRedux').reducer,
  happenings: require('./HappeningsRedux').reducer,
  posts: require('./PostsRedux').reducer,
  getFollow: require('./GetFollowRedux').reducer,
  userPopular: require('./UserPopularRedux').reducer,
  postPeople: require('./PostPeopleRedux').reducer,
  kargoeTag: require('./KargoeTagRedux').reducer,
  kargoeSearchTag: require('./KargoeSearchTagRedux').reducer,
  item: require('./ItemRedux').reducer,
  charity: require('./KargoeCareRedux').reducer,
  postdetails: require('./PostDetails2Redux').reducer,
  postCreation: require('./CreatePostRedux').reducer,
  order: require('./OrderRedux').reducer,
  love: require('./LoveRedux').reducer,
  actionSheet: require('./ActionSheetRedux').reducer,
  share  : require('./ShareRedux').reducer,
  footerWall  : require('./FootterWallRedux').reducer,
  readmore  : require('./ReadMoreRedux').reducer,
  shoppable  : require('./ShoppableRedux').reducer,
  coupon  : require('./CouponRedux').reducer,
  video  : require('./VideoRedux').reducer,
  appleMusic  : require('./AppleMusicRedux').reducer,
  form: formReducer,

})

// clear redux store on logout
// https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store/35641992#35641992

export const reducers = (state, action) => {
  if (action.type === 'LOGOUT_SUCCESS') {
    state = undefined
  }

  return appReducer(state, action)
}

export default () => {
  // let finalReducers = reducers
  // // If rehydration is on use persistReducer otherwise default combineReducers
  // if (ReduxPersist.active) {
  //   const persistConfig = ReduxPersist.storeConfig
  //   finalReducers = persistCombineReducers(persistConfig, reducers)
  // }else{
  //   finalReducers = persistCombineReducers(reducers)
//  }

  let { store, sagasManager, sagaMiddleware } = configureStore(reducers, rootSaga)

  if ( module.hot) {
    module.hot.accept(() => {

      const nextRootReducer = require('./').reducers
      store.replaceReducer( nextRootReducer)

      const newYieldedSagas = require('../Sagas').default

      sagasManager.cancel()
      sagasManager.done.then(() => {
        sagasManager = sagaMiddleware.run(newYieldedSagas)
      })
     //  persistStore(store, { storage: AsyncStorage }, onComplete);
    })
  }

  return store


}
